import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";

@Component({
  selector: "app-custom-col-table",
  templateUrl: "./custom-col-table.component.html",
  styleUrls: ["./custom-col-table.component.scss"],
})
export class CustomColTableComponent implements OnInit {
  @Input() item: any;
  @Input() element: any;

  constructor(
    private dateFormatterService: DateFormatterService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  setWidth(width: any) {
    let styles = {
      width: width + "%",
    };
    return styles;
  }

  date_format(date: any, type: string = "datetime") {
    if (type == "date") {
      return this.dateFormatterService.showDate(date);
    } else {
      return this.dateFormatterService.showDateHour(date);
    }
  }

  get_value() {
    let value =
      this.element.field_relation == ""
        ? (this.element.hasOwnProperty("sub_string")
            ? this.element.sub_string
              ? this.item[this.element.key].substr(0, 12) + "..."
              : this.item[this.element.key]
            : this.item[this.element.key] == null
            ? "---"
            : this.item[this.element.key]) +
          " " +
          this.element.concat_value
        : (this.item[this.element.key] == null
            ? "---"
            : this.item[this.element.key][this.element.field_relation]) +
          " " +
          this.element.concat_value;

    return value;
  }

  get_card_value() {
    let value = "";
    this.element.keys.forEach((key_item: any) => {
      if (key_item.field_relation == "") {
        if (this.item[key_item.key] != null && this.item[key_item.key] != "") {
          let text_value = this.item[key_item.key];

          if (
            key_item.concat_field_before != null &&
            key_item.concat_field_before != undefined &&
            key_item.concat_field_before != "" &&
            this.item[key_item.concat_field_before] != null &&
            this.item[key_item.concat_field_before] != ""
          ) {
            text_value = this.item[key_item.concat_field_before] + text_value;
          }

          if (
            key_item.concat_field_after != null &&
            key_item.concat_field_after != undefined &&
            key_item.concat_field_after != "" &&
            this.item[key_item.concat_field_after] != null &&
            this.item[key_item.concat_field_after] != ""
          ) {
            text_value = text_value + this.item[key_item.concat_field_after];
          }

          value +=
            '<span class="' +
            key_item.class +
            '">' +
            text_value +
            "</span><br>";
        } else {
          value += "";
        }
      } else {
        if (
          this.item[key_item.key][key_item.field_relation] != null &&
          this.item[key_item.key][key_item.field_relation] != ""
        ) {
          let text_value = this.item[key_item.key][key_item.field_relation];

          value +=
            '<span class="' +
            key_item.class +
            '">' +
            text_value +
            "</span><br>";
        } else {
          value += "";
        }
      }
    });
    return value;
  }

  timestamp_to_date_format(timestamp: any) {
    let value = "";
    if (timestamp != "" && timestamp != null && timestamp != "null") {
      let date = new Date(timestamp * 1000);
      value = this.dateFormatterService.showDateHour(date);
    } else {
      value = "---";
    }
    return value;
  }

  get_value_check() {
    let html = "";
    if (this.element.operation == "empty") {
      html =
        this.item[this.element.key] == "" ||
        this.item[this.element.key] == null ||
        this.item[this.element.key] == "null"
          ? this.element.yes
          : this.element.no;
    }
    if (this.element.operation == "boolean") {
      html =
        this.item[this.element.key] == true
          ? this.element.yes
          : this.element.no;
    }
    return html;
  }

  get_value_relation_list_with_filter(itemList: any) {
    let value = itemList[this.element.text];
    if (
      value != null &&
      value != "" &&
      this.element.concat_key != "" &&
      this.element.concat_key != null &&
      this.element.concat_key != undefined &&
      itemList[this.element.concat_key] != undefined &&
      itemList[this.element.concat_key] != null
    ) {
      value += " | " + itemList[this.element.concat_key];
    }

    if (
      value != null &&
      value != "" &&
      this.element.concat_text != "" &&
      this.element.concat_text != null &&
      this.element.concat_text != undefined
    ) {
      value += " " + this.element.concat_text;
    }
    return value;
  }

  go_to_route_relation_list_with_filter(itemList: any) {
    if (
      this.element.route != "" &&
      this.element.route != null &&
      this.element.route != undefined
    ) {
      this.router.navigate([
        this.element.route + "/" + itemList[this.element.index],
      ]);
    }
  }
}
